import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mdiBoomGate, mdiDesk, mdiEthernetCable, mdiFloorPlan, mdiWall } from '@mdi/js';
import streetLampArmUrl from '@rapideditor/temaki/icons/street_lamp_arm.svg?url';
import utilityPoleUrl from '@rapideditor/temaki/icons/utility_pole.svg?url';
import {
  faArchway, faArrowPointer, faArrowRight, faBan, faBorderAll, faBoxArchive,
  faBuilding, faBullseye, faCarSide, faChair, faCheck, faChevronDown, faCube,
  faChevronLeft, faChevronRight, faChevronUp, faClock, faCrosshairs,
  faDesktop, faDoorOpen, faEllipsis, faExpand, faEye, faFileArrowDown,
  faFileArrowUp, faFileImage, faFileLines, faFloppyDisk, faFolder,
  faGripVertical, faHand, faHouse, faLayerGroup, faLightbulb, faList,
  faMagnifyingGlass, faMagnifyingGlassLocation, faMapLocationDot, faMinus, faMoon,
  faMountainSun, faNetworkWired, faPerson, faPersonWalkingArrowRight, faPlus,
  faPrint, faRightFromBracket, faRoad, faRotateLeft, faRotateRight,
  faRoute, faRulerHorizontal, faServer, faShareNodes, faShieldHalved,
  faSquareParking, faStairs, faSun, faTableCellsLarge,
  faTrashCan, faUpload, faVideo,
  faWandMagicSparkles, faXmark
} from '@fortawesome/free-solid-svg-icons';

const icons = {
  sites: faMapLocationDot, camera: faVideo, light: faLightbulb, archive: faBoxArchive,
  plus: faPlus, search: faMagnifyingGlass, grid: faTableCellsLarge, list: faList,
  arrow: faArrowRight, layers: faLayerGroup, shield: faShieldHalved, logout: faRightFromBracket, folder: faFolder,
  clock: faClock, chevron: faChevronRight, 'chevron-right': faChevronRight,
  'chevron-left': faChevronLeft, 'chevron-up': faChevronUp, 'chevron-down': faChevronDown,
  check: faCheck, file: faFileLines, save: faFloppyDisk, pointer: faArrowPointer,
  pan: faHand, exclude: faBan,
  zone: faBullseye, inspect: faMagnifyingGlassLocation, scale: faRulerHorizontal,
  outdoor: faMountainSun, building: faBuilding, parking: faSquareParking, road: faRoad,
  entrance: faPersonWalkingArrowRight, vehicle: faCarSide,
  door: faDoorOpen, window: faBorderAll, stairs: faStairs, passage: faArchway,
  obstacle: faCube, task: faRoute, person: faPerson,
  chair: faChair, equipment: faServer, undo: faRotateLeft,
  redo: faRotateRight, delete: faTrashCan, more: faEllipsis, sun: faSun,
  system: faDesktop, moon: faMoon, expand: faExpand,
  magic: faWandMagicSparkles, eye: faEye, grip: faGripVertical, target: faCrosshairs,
  share: faShareNodes, report: faPrint, import: faUpload, export: faFileArrowDown,
  'file-import': faFileImage, 'file-export': faFileArrowUp, network: faNetworkWired,
  home: faHouse, minus: faMinus, close: faXmark
};

const sourcedIcons = {
  wall: { path: mdiWall, viewBox: '0 0 24 24' },
  floor: { path: mdiFloorPlan, viewBox: '0 0 24 24' },
  gate: { path: mdiBoomGate, viewBox: '0 0 24 24' },
  desk: { path: mdiDesk, viewBox: '0 0 24 24' },
  cable: { path: mdiEthernetCable, viewBox: '0 0 24 24' },
  'light-pole': { maskUrl: streetLampArmUrl },
  'utility-pole': { maskUrl: utilityPoleUrl }
};

export default function Icon({ name, size = 18, className = '', style, ...props }) {
  const sourced = sourcedIcons[name];
  if (sourced?.maskUrl) {
    const mask = `url("${sourced.maskUrl}") center / contain no-repeat`;
    return <span className={`svg-inline--fa sourced-icon ${className}`.trim()} aria-hidden="true"
      style={{ width: size, height: size, backgroundColor: 'currentColor', WebkitMask: mask, mask, ...style }} {...props} />;
  }
  if (sourced?.path) {
    return <svg viewBox={sourced.viewBox} className={`svg-inline--fa sourced-icon ${className}`.trim()}
      width={size} height={size} style={style} aria-hidden="true" {...props}>
      <path fill="currentColor" d={sourced.path} />
    </svg>;
  }
  return <FontAwesomeIcon icon={icons[name] || icons.sites} className={className}
    width={size} height={size} style={style} aria-hidden="true" {...props} />;
}
